import { Modal, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';
import useStyles from './style';
import { IModalProps } from './types';

const ModalCard = ({ children, title, open, onClose }: IModalProps) => {
  const classes = useStyles();
  return (
    <Modal open={open} onClose={onClose} className={classes.presentation}>
      <div className={classes.modalPresentation}>
        <div className={classes.modalCard}>
          <div className={classes.modalHeader}>
            <span>{title}</span>
            <Close className={classes.headerIcon} onClick={onClose} />
          </div>
          {children}
          <div className={classes.modalFooter}>
            <Button color="primary" onClick={onClose}>
              FECHAR
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default ModalCard;
